<template>
  <div>
    <!-- mobile view if user is serving ads -->
    <div v-if="currentView == 'analytics'">
      <!-- dashboard -->
      <div
        id="campaign-dashboard"
        :data-adacado-dataset="analyticsDataset"
        style="background-color: white;"
      >
        <div v-pre class="campaignDashboardWrapper"></div>
      </div>
    </div>
    <!-- mobile view if user selected save and continue -->
    <!-- mobile view if user selected 3rd-party dsp ad tags -->
    <div v-else style="height: calc(100vh - 87px); overflow: auto;">
      <div class="text-h5 px-3 font-weight-bold text-center" style="margin-top: 100px;"
        >Your Ads Have Been Saved To Your Account</div
      >
      <div class="d-flex justify-center">
        <v-btn
          class="mt-5"
          small
          dark
          color="orange"
          @click="
            guibus_publish('dispatch:beacon', {
              eventId: `welcome-mobile_complete_preview_ads_button-click`,
            })
            previewAds()
          "
          >Preview My Ads</v-btn
        >
      </div>
      <div v-if="currentView == 'saveAndContinue'" class="px-6 paragraphText">
        <div class="my-5">
          Your ads have been saved to your account and are ready to be served. If you're ready to
          go, you can simply launch your Freemium Ads through Adacado right now by clicking on the
          "Serve My Ads" button below.
        </div>
        <div>
          If you wish to explore the rest of the platform, or make changes to your ads, you'll need
          to login on a device with a larger screen.
        </div>
      </div>
      <div v-else class="px-6 paragraphText">
        <div class="my-5">
          Your ads have been saved to your account and are ready to be served. Because you opted to
          use a 3rd-party DSP, you'll need to login and finish your configuration on a device with a
          larger screen (ie. desktop/laptop), where you can enter your credit card info and copy the
          ad tags.
        </div>
      </div>
      <div v-if="currentView == 'saveAndContinue'" class="d-flex justify-center">
        <v-btn
          class="my-5"
          x-large
          dark
          color="orange"
          @click="
            guibus_publish('dispatch:beacon', {
              eventId: 'welcome-mobile_complete_serve_ads_via_adacado_button-click',
            })
            $emit('handleServeMyAds')
          "
          >Serve My Ads</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import FemsService from 'fems-service'
import EnvService from 'env-service'
import Parameter from 'parameter-mixin'
export default {
  mixins: [Parameter],
  props: {
    currentView: {
      type: String,
      default: '',
    },
    advertiserId: {
      type: Number,
      required: true,
    },
    campaignId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showAdPreviewModal: false,
    }
  },
  computed: {
    analyticsDataset() {
      return this.$constructAdacadoDataset({
        advertiserId: this.advertiserId,
        campaignId: this.campaignId,
        isMobile: true,
      })
    },
    isProductionEnv() {
      return EnvService.IS_PRODUCTION_CONNECTION
    },
  },
  beforeMount() {
    if (this.currentView == 'analytics') {
      FemsService.renderChildFems('campaign-dashboard', 'v2')
    }
  },
  watch: {
    currentView(newVal) {
      if (newVal == 'analytics') {
        FemsService.renderChildFems('campaign-dashboard', 'v2')
      }
    },
  },
  methods: {
    previewAds() {
      window.open(
        `https://${this.isProductionEnv ? '' : 'staging-'}go.adacado.com/preview/v1/${
          this.advertiserId
        }/${this.campaignId}`,
        '_blank'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.paragraphText {
  color: #9e9e9e;
}
</style>
